export class AppStateActive {
    public static readonly type = '[Root state] App state active';
}
